<script lang="ts">
  // The diff options bar's algorithm choice: a labeled select whose
  // tooltip says when the chosen algorithm helps, disabled while the
  // engine is unavailable.
  import type { DiffAlgorithm } from '../engine/types';
  import { ALGORITHMS, algorithmOf } from '../diff/algorithms';
  import { engineDegraded } from '../diff/engine';

  let { value, onchange }: { value: DiffAlgorithm; onchange: (a: DiffAlgorithm) => void } = $props();
  /** Without the engine there is one alignment, so there is nothing to choose. */
  const disabled = $derived(engineDegraded());
  const current = $derived(ALGORITHMS.find((a) => a.id === value) ?? ALGORITHMS[0]);
  /** Without the engine there is one alignment: GitHub's (or a plain Myers diff). */
  const DISABLED_TITLE = 'The diff options need the diff engine, which did not load: this shows the fewest changed lines, as GitHub does. Reload the page to try again.';
</script>

<label class="algorithm-control" title={disabled ? DISABLED_TITLE : current.title}
  >Diff
  <select
    aria-label="Diff algorithm"
    {value}
    {disabled}
    onchange={(e) => onchange(algorithmOf((e.currentTarget as HTMLSelectElement).value))}
  >
    {#each ALGORITHMS as a (a.id)}
      <option value={a.id} title={a.title}>{a.label}</option>
    {/each}
  </select></label
>

<style>
  .algorithm-control {
    height: 40px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    white-space: nowrap;
  }
  select {
    font: inherit;
    color: var(--fg);
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: 6px;
    padding: 3px 4px;
  }
</style>
